import { Link } from 'react-router-dom'
import { controls, common } from '@ocean/ui'
import { NoteWrapper } from './FinalState.styled'

const { Button } = controls
const { Note } = common

type FinalStateProps = {
  title: string
  description: string
  backText: string
  backPath: string
  dataTest?: string
}

const FinalState: React.FC<FinalStateProps> = ({
  title,
  description,
  backText,
  backPath,
  dataTest = '',
}) => {
  return (
    <>
      <NoteWrapper>
        <Note title={title} description={description} dataTest={`${dataTest}Note`} />
      </NoteWrapper>
      <Link to={backPath}>
        <Button fill title={backText} dataTest={`${dataTest}Button`} />
      </Link>
    </>
  )
}

export default FinalState
